import type { Block } from '@/types';

/** Backend preset voor UBX HubSpot-implementatie-offertes. */
export const UBX_PRESET_ID = 'ubx_groeiprogramma';

export function defaultAgencyLogoUrl(theme?: 'ubo' | 'ubx'): string {
  return theme === 'ubx' ? '/ubo/ubx-logo.svg' : '/ubo/logo.svg';
}

/**
 * Bepaalt UBX vs UBO voor de hele offerte (editor, publieke pagina, TipTap-secties).
 * Eerst layout-preset, anders eerste blok met theme ubx.
 */
export function inferQuotePageBrand(
  blocks: Block[],
  layoutConfig?: Record<string, unknown> | null
): 'ubo' | 'ubx' {
  const preset = layoutConfig?.presetId;
  if (preset === UBX_PRESET_ID) return 'ubx';
  for (const b of blocks) {
    const c = b.content as { theme?: string } | undefined;
    if (c?.theme === 'ubx') return 'ubx';
  }
  return 'ubo';
}

/**
 * Agency-logo-URL: ontbrekend of legacy `/ubo/logo.svg` → theme-default (UBX → ubx-logo.svg).
 */
export function resolveAgencyLogoUrl(
  stored: string | null | undefined,
  theme?: 'ubo' | 'ubx'
): string {
  const t = theme ?? 'ubo';
  const def = defaultAgencyLogoUrl(t);
  if (stored == null || stored === '') return def;
  if (t === 'ubx' && stored === '/ubo/logo.svg') return def;
  return stored;
}
